// @ts-nocheck
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react';

import { useField } from '@unform/core';

import { Field, FormCheckbox, LabelCheckbox } from './styled';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: React.ReactNode;
  onChange?: any;
  controller?: ['S' | 'N', React.Dispatch<React.SetStateAction<'S' | 'N'>>];
  initialValue?: 'S' | 'N';
  noMargin?: boolean;
  withPadding?: boolean;
}

const Checkbox: React.FC<InputProps> = ({
  name,
  label,
  onChange,
  controller,
  initialValue,
  noMargin,
  withPadding,
  ...rest
}: InputProps) => {
  const { fieldName, error, registerField, clearError } = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);
  const controllerComponent = useState(initialValue);

  const [valueIpt, setValueIpt] = controller || controllerComponent;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => (ref.current.checked ? 'S' : 'N'),
      clearValue: () => {
        // eslint-disable-next-line no-param-reassign
        setValueIpt('N');
      },
      setValue: (ref, value: 'S' | 'N') => {
        // eslint-disable-next-line no-param-reassign
        setValueIpt(value);
      },
    });
  }, [fieldName, registerField, setValueIpt]);

  function handleOnChange(event: React.SyntheticEvent<HTMLInputElement>) {
    clearError();
    setValueIpt(event.currentTarget.checked ? 'S' : 'N');
    if (onChange) onChange(event);
  }
  return (
    <Field noMargin={noMargin}>
      <LabelCheckbox
        disabled={rest.disabled || false}
        checked={valueIpt === 'S'}
        isError={!!error}
        withPadding={withPadding}
      >
        <>{label}</>
        <FormCheckbox
          ref={inputRef}
          type="checkbox"
          name={name}
          checked={valueIpt === 'S'}
          disabled={rest.disabled}
          onChange={handleOnChange}
          data-cy={name}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
        />
      </LabelCheckbox>
    </Field>
  );
};

Checkbox.defaultProps = {
  label: false,
  onChange: undefined,
  controller: undefined,
  initialValue: 'N',
  noMargin: false,
  withPadding: false,
};

export default Checkbox;
